import type { Currency } from "@opensea/app-kit"
import { bn } from "@opensea/utils"

export const convertTokenToUsd = (
  quantity: string,
  currency: Currency,
  decimals = 2,
) => {
  return bn(quantity)
    .times(currency.usdPrice)
    .decimalPlaces(decimals)
    .toString()
}

export const convertUsdToToken = (quantity: string, currency: Currency) => {
  return bn(quantity).div(currency.usdPrice).toString()
}
